// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1T5fM","range":"MonthRangeSwitch_range__3_cA8","disabled":"MonthRangeSwitch_disabled__1PbWe"};